export default __webpack_public_path__ + "static/media/sound-on-circle.b24e6ade.svg";